import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, EMPTY, forkJoin } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ApiService } from '../core/api.service';
import { Key } from '../core/models/key';
import { Lesson } from '../core/models/lesson';
import { SystemService } from '../core/system.service';


@Injectable({
  providedIn: 'root'
})
export class KeylessonPlayerResolverService implements Resolve<{keyboardKeys: Key[], allowedKeys: string[]}> {
  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private systemService: SystemService,
    private router: Router) { } 

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<{keyboardKeys: Key[], allowedKeys: string[]}> | Observable<never> {
    const id = +route.parent.paramMap.get('id');
    
    const { userid, keyboard_in_use, language_in_use } = this.authService.user$.value;
    if(!this.systemService.inGameMode$.value) { 
      this.router.navigate(['keylesson']);
      return EMPTY;
    }


    const requests = [
      this.apiService.loadKeyboardKeys(userid, keyboard_in_use, language_in_use),
      this.apiService.loadAllowedLetters(userid, id, language_in_use)
    ];

    return forkJoin([...requests])
      .pipe(
        mergeMap((values:any[]) => {
        if(!values) { return EMPTY }

        // keyboard keys
        const keyboardKeysResult = values[0];
        const keyboardKeys: Key[] = keyboardKeysResult.the_keys.key.map(value => {
          return {
            ...value,
            hide_dead_key: value.hide_dead_key === 'yes',
            useAltGr: value.useAltGr === 'yes', 
            useShift: value.useShift === 'yes'
          }
        });

        // allowed letters
        const allowedKeysResult = values[1]
        const allowedKeys: string[] = allowedKeysResult.letters.letter;


        return of({ keyboardKeys: keyboardKeys, allowedKeys: allowedKeys });

        })
      );
  }


  private processBookmarks(bookmarks: string[]): string {
    // check first entry 
    const parts = bookmarks[0].split(' ');
    if(parts.length > 3) { return ''};

    // should return last bookmarked date
    return parts[0];

  }

  private processBestExercise(bestExercises: string[]): string {
    // check first entry 
    const parts = bestExercises[0].split(' ');
    if(parts.length > 3) { return ''};

    // should return max exercise done
    const numbers = bestExercises.map(value => +value).filter(value => !isNaN(value))
    return Math.max(...numbers).toString();

  }


}